<template>
	<div>
		<slot name="header" />
		<div v-if="pending">
			<div v-for="index in 6" :key="index" class="skeleton-gradient h-5 w-full mb-2 rounded-lg" />
		</div>
		<table v-if="!pending" class="[&_tr+tr>th]:pt-1 [&_tr+tr>td]:pt-1">
			<thead class="sr-only">
				<tr>
					<th scope="col" class="text-left">
						Program
					</th>
					<th v-if="canRenderMiddleCells" scope="col" class="text-right">
						Služba
					</th>
					<th scope="col" class="text-right">
						Cena
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in pricelist.items" :key="item._uid">
					<th scope="row" class="font-normal text-left max-sm:w-full" v-text="item.title" />
					<td v-if="canRenderMiddleCells" class="pl-4 text-right text-sm">
						<span class="max-sm:hidden">{{ item.description }}</span>
					</td>
					<td class="pl-4 text-right" v-text="item.price" />
				</tr>
			</tbody>
		</table>
		<slot name="footer" />
	</div>
</template>

<script setup lang="ts">
	import type {CarWashPricelistItemStoryblok, CarWashPricelistStoryblok} from '~/storyblok/types';

	interface Props {
		pricelist: Omit<CarWashPricelistStoryblok, 'items'> & {
			items?: readonly CarWashPricelistItemStoryblok[]
		}
		pending?: boolean
	}

	const props = defineProps<Props>();

	const canRenderMiddleCells = computed(() => {
		return props.pricelist.items?.some((item) => item.description);
	});
</script>
